import {CommonReducer, ReducerFromState} from "../../@types/reducers";
import {User} from "../../@types/response";

export default (state: ReducerFromState<CommonReducer>): undefined | User => state.common.client;